import {getData, postData} from './redux_data';
import {
    GET_GRUPO_PARTIDA,
    MODIFY_GRUPO_PARTIDA,
    ADD_GRUPO_PARTIDA,
    DELETE_GRUPO_PARTIDA,
    UPDATE_GRUPO_PARTIDA,
} from '../constants/action_types';

export function getGrupoPartida() {
    return getData('Cvgrupopartidas', GET_GRUPO_PARTIDA);
}

export function modifyGrupoPartida(grupoPartida) {
    return (dispatch, getState) => {
        dispatch({ type: MODIFY_GRUPO_PARTIDA, payload: grupoPartida });
    }
}

export function addGrupoPartida(grupoPartida) {
    return (dispatch, getState) => {
        dispatch({ type: ADD_GRUPO_PARTIDA, payload: grupoPartida });
    }
}

export function removeGrupoPartida(grupoPartida) {
    return (dispatch, getState) => {
        dispatch({ type: DELETE_GRUPO_PARTIDA, payload: grupoPartida });
    }
}

export function updateGrupoPartidaDB (grupoPartida) {
    // return (dispatch, getState) => {
    //     dispatch({ type: UPDATE_GRUPO_PARTIDA, payload: grupoPartida })
    //     let token = getState().oidc.user ? getState().oidc.user.access_token : "";
    //     axios.post(config.API_URI() + 'cvgrupopartidas/grupos', grupoPartida,
    //         {
    //             headers: {
    //                 Authorization: "Bearer " + token
    //             }
    //         }
    //     ).then((response) => {
    //         dispatch({ type: UPDATE_GRUPO_PARTIDA + "_SUCCESS", payload: response })
    //         dispatch({
    //             type: OPEN_DIALOG,
    //             modalType: 'SimpleMessage',
    //             modalProps: { message: 'Cambios guardados!' },
    //             dialogid: 'success_update_grupo_partida'
    //             });
    //     }).catch((error) => {
    //         dispatch({
    //             type: OPEN_DIALOG,
    //             modalType: 'SimpleMessage',
    //             modalProps: { message: error.response.data.message, exception: error.response.data.ex },
    //             dialogid: 'error_update_grupo_partida'
    //             });
    //     });
    // }

    return postData('cvgrupopartidas/grupos', UPDATE_GRUPO_PARTIDA, grupoPartida, 'Grupos de partida actualizados', undefined);

}

